import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { IconProps, Link } from '@printdeal/ui-library';

// Helpers
import {
  dispatchDataLayerEventOnAccountItemClick,
} from '../../../../helpers/dataLayerHelpers/accountDashboardDataLayerHelper';

interface DashboardLinkProps {
  to: string;
  title: React.ReactNode;
  text: string;
  icon: IconProps['icon'];
  badgeAfter?: React.ReactNode;
  onClickEvent?: (arg0: any) => void;
}

const AccountLink = ({
  to,
  title,
  text,
  icon,
  badgeAfter,
  onClickEvent = dispatchDataLayerEventOnAccountItemClick,
}: DashboardLinkProps) => (
  <li
    key={`account-nav-item-${text}`}
    className="pd-border-b pd-py-2 last:pd-border-b-0"
  >
    <Link
      as={GatsbyLink}
      to={to}
      variant="secondary"
      iconBefore={icon}
      onClick={() => {
        onClickEvent(text);
      }}
      data-cy={`${text}PageLink`}
      className="pd-flex"
    >
      { title }
      { badgeAfter }
    </Link>
  </li>
);

export default AccountLink;
